import React from 'react'
import { globalState } from '@codeleap/store'
import { SuccessOverlay } from '../SuccessOverlay'

const visible = globalState(false)

export const ContributeSuccessOverlay = ({ type }) => {
  const isVisible = visible.use()

  return (
    <SuccessOverlay
      visible={isVisible}
      icon='send-primary3'
      title={`Your ${type} has been posted!`}
      description={<>This content will now appear in the Hurd feed<br />for you and the entire community.</>}
    />
  )
}

ContributeSuccessOverlay.show = (delay = 3500) => {
  visible.set(true as never)
  setTimeout(() => visible.set(false as never), delay)
}

ContributeSuccessOverlay.close = () => visible.set(false as never)